<script lang="ts">
    import { onMount } from 'svelte';
    import { getPathParams } from 'svelte-mini-router';
    import { translate } from '@/utils/format';
    import { goTo } from '@/utils/router';
    import { getSsoSession } from '@/services/sso';
    import { Spinner } from '@/components';

    let partnerId = $state('');
    let partnerName = $state('');
    let generating = $state(true);

    onMount(async () => {
        const params = getPathParams();
        partnerId = String(params?.['partnerId'] || '').trim();
        if (!partnerId) { goTo('/'); return; }

        const session = getSsoSession();
        partnerName = session?.branding?.partnerName ?? partnerId;

        // Fase 2: generación real del avatar Niji
        // Por ahora: placeholder estático con delay simulado
        await new Promise((r) => setTimeout(r, 1800));
        generating = false;
    });
</script>

<section class="ssoTunigi">
    <header class="ssoTunigi__header">
        <h1 class="ssoTunigi__title">{translate('NJO_TUNIGI_TITLE', 'Tu avatar nutricional')}</h1>
        <p class="ssoTunigi__desc">{translate('NJO_TUNIGI_DESC', 'Generando tu representación visual personalizada...')}</p>
    </header>

    <div class="ssoTunigi__canvas">
        {#if generating}
            <div class="ssoTunigi__generating">
                <Spinner text="" />
                <p class="ssoTunigi__genLabel">{translate('NJO_TUNIGI_DESC', 'Generando...')}</p>
            </div>
        {:else}
            <!-- Placeholder visual estático — Fase 2: imagen generada por IA -->
            <div class="ssoTunigi__placeholder">
                <div class="ssoTunigi__avatar">🧬</div>
                <p class="ssoTunigi__avatarNote">Avatar Niji — Fase 2</p>
            </div>
        {/if}
    </div>

    <button
        class="ssoTunigi__cta"
        type="button"
        onclick={() => goTo(`/${partnerId}/companion`)}
        disabled={generating}
    >
        {translate('NJO_SAVE_PROFILE', 'Activar seguimiento completo')}
    </button>

    <p class="ssoTunigi__poweredBy">{translate('SSO_POWERED_BY', 'powered by Caloo')}</p>
</section>

<style lang="scss">
    .ssoTunigi {
        min-height: 100vh;
        background: var(--backgroundMain);
        color: var(--textColor);
        display: grid;
        align-content: start;
        gap: 24px;
        padding: 40px 20px;
        font-family: 'Montserrat', sans-serif;
    }

    .ssoTunigi__header {
        display: grid;
        gap: 8px;
        text-align: center;
    }

    .ssoTunigi__title {
        margin: 0;
        font-size: 24px;
        font-weight: 900;
        color: var(--black);
        letter-spacing: -0.02em;
    }

    .ssoTunigi__desc {
        margin: 0;
        font-size: 14px;
        color: var(--subtleText);
        line-height: 1.45;
    }

    .ssoTunigi__canvas {
        width: 100%;
        aspect-ratio: 1 / 1;
        max-width: 320px;
        justify-self: center;
        border-radius: 24px;
        border: 1px solid var(--border);
        background: var(--white);
        display: grid;
        place-items: center;
        overflow: hidden;
    }

    .ssoTunigi__generating,
    .ssoTunigi__placeholder {
        display: grid;
        place-items: center;
        gap: 12px;
        text-align: center;
    }

    .ssoTunigi__genLabel {
        font-size: 13px;
        color: var(--subtleText);
    }

    .ssoTunigi__avatar {
        font-size: 80px;
        line-height: 1;
    }

    .ssoTunigi__avatarNote {
        font-size: 12px;
        color: var(--subtleText);
        opacity: 0.6;
        margin: 0;
    }

    .ssoTunigi__cta {
        width: 100%;
        padding: 16px 24px;
        border: none;
        border-radius: 14px;
        background: linear-gradient(180deg, #5aeaa0 0%, var(--partner-primary, var(--primary)) 100%);
        color: #12121f;
        font-size: 15px;
        font-weight: 900;
        font-family: inherit;
        cursor: pointer;
        box-shadow: 0 4px 14px rgba(76, 227, 157, 0.25);
        transition: opacity 0.15s, transform 0.12s;
    }

    .ssoTunigi__cta:disabled {
        opacity: 0.45;
        cursor: not-allowed;
        background: var(--border);
        box-shadow: none;
    }

    .ssoTunigi__poweredBy {
        font-size: 11px;
        color: var(--subtleText);
        opacity: 0.5;
        text-align: center;
        letter-spacing: 0.04em;
    }
</style>
